import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../components/ui';
import { Icon } from '../../../../components/icons';
import {
  v2FamilyAccounts,
  type FamilyAccount, type FamilyAccountInput,
} from '../../../../lib/familyAccounts';
import { Field, Text, Area } from '../../profile/controls';

export function AccountForm({
  account, dark, onSaved, compact = false,
}: {
  account: FamilyAccount | null;
  dark: boolean;
  onSaved: (a: FamilyAccount) => void;
  compact?: boolean;
}) {
  const { t: tr } = useTranslation();
  const [name, setName] = useState(account?.name ?? '');
  const [notiz, setNotiz] = useState(account?.notiz ?? '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [msg, setMsg] = useState<string | null>(null);

  const save = async () => {
    if (saving) return;
    setSaving(true);
    setError(null);
    setMsg(null);
    const input: FamilyAccountInput = { name: name || null, notiz: notiz || null };
    try {
      const result = account
        ? await v2FamilyAccounts.update(account.id, input)
        : await v2FamilyAccounts.create(input);
      setMsg(account ? tr('pflege.familienkonto.detail.member_saved') : tr('pflege.familienkonto.detail.account_created'));
      onSaved(result);
    } catch (e) {
      const err = e as { response?: { data?: { errors?: Array<{ message?: string }>; message?: string } } };
      setError(err.response?.data?.errors?.[0]?.message ?? err.response?.data?.message ?? (e instanceof Error ? e.message : tr('pflege.edit.save_failed')));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Field dark={dark} label={tr('pflege.familienkonto.detail.account_name')}>
        <Text dark={dark} value={name} onChange={setName} placeholder="Familie Muster" />
      </Field>
      <Field dark={dark} label={tr('pflege.familienkonto.detail.notiz')}>
        <Area dark={dark} value={notiz} onChange={setNotiz} rows={compact ? 2 : 3} />
      </Field>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Button variant="primary" size="sm" dark={dark} onClick={save} disabled={saving} icon={<Icon.Check c="#fff" />}>
          {saving
            ? tr('pflege.edit.saving')
            : account ? tr('pflege.familienkonto.detail.save_account') : tr('pflege.familienkonto.detail.create_account')}
        </Button>
        {msg && <span style={{ fontSize: 12, color: '#039855', fontWeight: 600 }}>{msg}</span>}
        {error && <span style={{ fontSize: 12, color: '#b42318', fontWeight: 600 }}>{error}</span>}
      </div>
    </div>
  );
}
